import { useMemo } from "react";
import { PERMISSIONS } from "../utils/permissionCodes";
import { usePermissions } from "./usePermissions";
import { useTaskPermissions } from "./useTaskPermissions";

export function usePropertyDetailsPermissions() {
  const { hasPermission, hasAnyPermission } = usePermissions();
  const {
    canViewTasks,
    canCreateTasks,
    canUpdateTasks,
    canDeleteTasks,
  } = useTaskPermissions();

  const canViewContactsSection = hasAnyPermission([
    PERMISSIONS.CONTACTS.VIEW,
    PERMISSIONS.PROPERTIES.CONTACTS_ASSIGN,
    PERMISSIONS.PROPERTIES.CONTACTS_UNASSIGN,
  ]);
  const canViewCompaniesSection = hasAnyPermission([
    PERMISSIONS.COMPANIES.VIEW,
    PERMISSIONS.PROPERTIES.COMPANIES_ASSIGN,
    PERMISSIONS.PROPERTIES.COMPANIES_UNASSIGN,
  ]);
  const canViewPropertyImages = hasPermission(
    PERMISSIONS.PROPERTIES.IMAGES_VIEW,
  );
  const canUploadPropertyImages = hasPermission(
    PERMISSIONS.PROPERTIES.IMAGES_UPLOAD,
  );
  const canDeletePropertyImages = hasPermission(
    PERMISSIONS.PROPERTIES.IMAGES_DELETE,
  );
  const canViewPropertyImagesSection =
    canViewPropertyImages || canUploadPropertyImages || canDeletePropertyImages;
  const canUpdatePropertyNotes = hasPermission(
    PERMISSIONS.PROPERTIES.NOTES_UPDATE,
  );
  const canAssignContacts = hasPermission(
    PERMISSIONS.PROPERTIES.CONTACTS_ASSIGN,
  );
  const canUnassignContacts = hasPermission(
    PERMISSIONS.PROPERTIES.CONTACTS_UNASSIGN,
  );
  const canAssignCompanies = hasPermission(
    PERMISSIONS.PROPERTIES.COMPANIES_ASSIGN,
  );
  const canUnassignCompanies = hasPermission(
    PERMISSIONS.PROPERTIES.COMPANIES_UNASSIGN,
  );
  const canViewProcessStatuses = hasAnyPermission([
    PERMISSIONS.PROCESSES.VIEW,
    PERMISSIONS.PROCESSES.PROPERTY_STATUS_VIEW,
    PERMISSIONS.PROCESSES.PROPERTY_STATUS_UPDATE,
  ]);
  const canUpdateProcessStatuses = hasPermission(
    PERMISSIONS.PROCESSES.PROPERTY_STATUS_UPDATE,
  );
  return useMemo(
    () => ({
      canViewContactsSection,
      canViewCompaniesSection,
      canViewPropertyImages,
      canUploadPropertyImages,
      canDeletePropertyImages,
      canViewPropertyImagesSection,
      canUpdatePropertyNotes,
      canAssignContacts,
      canUnassignContacts,
      canAssignCompanies,
      canUnassignCompanies,
      canViewProcessStatuses,
      canUpdateProcessStatuses,
      canViewTasks,
      canCreateTasks,
      canUpdateTasks,
      canDeleteTasks,
    }),
    [
      canAssignCompanies,
      canAssignContacts,
      canCreateTasks,
      canDeletePropertyImages,
      canDeleteTasks,
      canUnassignCompanies,
      canUnassignContacts,
      canUpdateProcessStatuses,
      canUpdatePropertyNotes,
      canUpdateTasks,
      canUploadPropertyImages,
      canViewCompaniesSection,
      canViewContactsSection,
      canViewProcessStatuses,
      canViewPropertyImages,
      canViewPropertyImagesSection,
      canViewTasks,
    ],
  );
}
